import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation, AfterViewInit, HostListener, Renderer2, ElementRef } from '@angular/core';
import { IcdService, BASE } from '../../../../shared/services/icd.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { SearchService } from '../../../../shared/services/search.search';
import { EventManager } from '../../../../shared/services/broadcast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

interface ChapterNode {
    name: string;
    model: string;
    id: string;
    children?: ChapterNode[];
    level: number;
    isLeaf: boolean;
    code: string;
    span: any;
}

@Component({
    selector: 'app-icd10',
    templateUrl: './icd10.component.html',
    styleUrls: ['./icd10.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class Icd10Component implements OnInit {
    chapter: any[] = [];
    htmlRoot:any;
    infoModel: any;
    dataSource = new MatTreeNestedDataSource<ChapterNode>();
    treeControl = new NestedTreeControl<ChapterNode>((node) => node.children);
    loaded: Set<string> = new Set<string>();
    isActive: string | null = '';
    language: any;
    userCommentList: any[] = [];
    showingComments = false;
    userCaptcha: string = '';
    errorMessage: string | undefined;
    contentMessage: string | undefined;
    nameMessage: string | undefined;
    emailMessage: string | undefined;
    phoneMessage: string | undefined;
    subjectMessage: string | undefined;
    isSearching: boolean = false;
    public captchaImageUrl: string | undefined;

    modalEdit: any;

    constructor(
        private viewportScroller: ViewportScroller,
        private router: Router,
        private scroller: ViewportScroller,
        private route: ActivatedRoute,
        private eventManager: EventManager,
        public icdService: IcdService,
        private _changeDetectorRef: ChangeDetectorRef,
        private searchService: SearchService,
        private toastService: ToastrService,
        private renderer: Renderer2, private el: ElementRef
    ) {
        this.dataSource.data = [];
        this.eventManager.subscribe('changeLanguage', (lang: any) => {
            this.language = lang.content;
            this.getChapter();
        });
    }

    

    setClickForCopy() {
        // Tìm các icon fa-copy sau khi DOM đã được render
        setTimeout(() => {
            const copyIcons = this.el.nativeElement.querySelectorAll('.icon-copy');
            // Gắn sự kiện click cho mỗi icon
            copyIcons.forEach((icon: HTMLElement) => {
                this.renderer.listen(icon, 'click', () => {
                    this.copyToClipboard(icon);
                });
            });
        }, 100);
    }

    setClickForEdit() {
        // Tìm các icon fa-copy sau khi DOM đã được render
        setTimeout(() => {
            const editIcons = this.el.nativeElement.querySelectorAll('.icon-email');
            // Gắn sự kiện click cho mỗi icon
            editIcons.forEach((icon: HTMLElement) => {
                this.renderer.listen(icon, 'click', () => {
                    this.editContent(icon);
                });
            });
        },100 );
    }

    editContent(element: HTMLElement) {
        const content = element.parentElement?.parentElement?.getElementsByClassName('content')[0]?.innerHTML || '';
        const content_raw = element.parentElement?.getElementsByClassName('content-raw')[0]?.textContent || '';
        const field= element.parentElement?.getElementsByClassName('field')[0]?.textContent || '';
        const id = element.parentElement?.getElementsByClassName('id')[0]?.textContent || '';
        const model = element.parentElement?.getElementsByClassName('model')[0]?.textContent || '';

        // Lấy thông tin người gửi đã lưu nếu có
        const senderName = localStorage.getItem('senderName') || '';
        const senderEmail = localStorage.getItem('senderEmail') || '';

        // Đặt giá trị vào các input trong modal
        (document.getElementById('modal-content') as HTMLDivElement).innerHTML = content; // Nội dung HTML nhúng
        (document.getElementById('modal-id') as HTMLInputElement).value = id;
        (document.getElementById('modal-model') as HTMLInputElement).value = model;
        (document.getElementById('modal-field') as HTMLInputElement).value = field;
        (document.getElementById('modal-feedback') as HTMLTextAreaElement).value = '';
        (document.getElementById('modal-senderName') as HTMLInputElement).value = senderName;
        (document.getElementById('modal-senderEmail') as HTMLInputElement).value = senderEmail

        // Mở modal Bootstrap
        this.modalEdit = new (window as any).bootstrap.Modal(document.getElementById('editModal'));
        this.modalEdit.show();
    }

    submitFeedback() {
        // Lấy các giá trị từ form
        const id = (document.getElementById('modal-id') as HTMLInputElement).value;
        const model = (document.getElementById('modal-model') as HTMLInputElement).value;
        const field = (document.getElementById('modal-field') as HTMLInputElement).value;
        const content = (document.getElementById('modal-content') as HTMLDivElement).innerHTML;
        const feedback = (document.getElementById('modal-feedback') as HTMLTextAreaElement).value;
    
        // Lấy thông tin người gửi
        const senderName = (document.getElementById('modal-senderName') as HTMLInputElement).value;
        const senderEmail = (document.getElementById('modal-senderEmail') as HTMLInputElement).value;
    
        // Kiểm tra dữ liệu đã nhập (nếu cần)
        if (!feedback.trim() || !senderName.trim() || !senderEmail.trim()) {
        //   alert('Vui lòng điền đầy đủ thông tin và góp ý!');
            this.toastService.error('Vui lòng điền đầy đủ thông tin và góp ý!', 'Gửi góp ý thất bại');
            return;
        }

        this.toastService.info('Đang gửi góp ý...', 'Đang xử lý');
    
        // Xử lý gửi dữ liệu
        const formData = {
            id: id,
            model: model,
            field: field,
            content: content,
            feedback: feedback,
            senderName: senderName,
            senderEmail: senderEmail,
        };
    
        // Thực hiện gửi form (có thể là gọi API)
        this.icdService.quickFeedback(formData, 'ICD10').subscribe(
            (res: any) => {
                if (res.status === 'success'){
                    this.toastService.success(`${res?.message}`, 'Gửi góp ý thành công');
                    this.toastService.success(`Góp ý đã được gửi thành công! Cảm ơn bạn đã đóng góp ý kiến "${feedback}"!`, 'Thành công');
                    // Đóng modal sau khi gửi
                    this.modalEdit.hide();
                    
                    // Lưu lại thông tin người gửi để lần sau không cần nhập lại
                    localStorage.setItem('senderName', senderName);
                    localStorage.setItem('senderEmail', senderEmail);
                }
                else {
                    // console.log(res);
                    this.toastService.error(`${res?.message}`, 'Gửi góp ý thất bại');
                }
            },
            (error: any) => {
                // console.log(error);
                this.toastService.error(`Lỗi khi gửi góp ý: ${error?.error.message}`, 'Gửi góp ý thất bại');
            }
        );
    }

    copyToClipboard(element: HTMLElement) {
        const content = element.parentElement?.getElementsByClassName('content-raw')[0]?.textContent;
        if (content) {
          navigator.clipboard.writeText(content).then(() => {
            // alert('Đã sao chép: ' + content);
            this.toastService.success('Đã sao chép: ' + content, 'Sao chép thành công');
          }).catch(err => {
            console.error('Không thể sao chép vào clipboard', err);
            this.toastService.error('Không thể sao chép vào clipboard', 'Sao chép thất bại');
          });
        }
    }

    hasChild = (_: number, node: ChapterNode) => !node.isLeaf;

    ngOnInit(): void {
        this.language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'vi';
        this.getChapter();
        this.isActive = this.route.snapshot.queryParamMap.get('id');
        this.getListFeedback();
    }

    getChapter() {
        this.icdService.getChapter(this.language).subscribe((res) => {
            this.chapter = res.data.map((value: any) => this.convertChapter(value));
            this.dataSource.data = this.chapter;
            this.infoModel = res.html;
            this.treeControl.dataNodes = this.chapter;
        });
    }

    getListFeedback() {
        this.icdService.getListFeedback10().subscribe((res) => {
            this.userCommentList = res.data;
        });
    }

    toggleForm() {
        this.showingComments = !this.showingComments;
    }

    submitForm() {
        const feedbackData = this.getFeedbackData();
        this.icdService.submitFeedback(feedbackData).subscribe(
            (res: any) => {
                if (res.status === 'success')
                    this.toastService.success(`${res?.message}`, 'Thành công');
                else this.toastService.error(`${res?.message}`, 'Thất bại');
                if (res.captcha_image && this.captchaImageUrl !== res.captcha_image) {
                    const newCaptchaImageUrl = BASE + res.captcha_image;
                    this.updateCaptchaImage(newCaptchaImageUrl);
                    this.userCaptcha = '';
                } else {
                    this.handleSuccess(res);
                }
            },
            (error: any) => {
                this.handleError(error);
            }
        );
    }

    private getFeedbackData() {
        const name = (document.getElementById('name') as HTMLInputElement).value;
        const number = (document.getElementById('number') as HTMLInputElement).value;
        const email = (document.getElementById('email') as HTMLInputElement).value;
        const title = (document.getElementById('title') as HTMLInputElement).value;
        const feedback = (document.getElementById('feedback') as HTMLTextAreaElement).value;
        //get csrf token from cookie
        let csrftoken = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, 10) === 'csrftoken' + '=') {
                    csrftoken = decodeURIComponent(cookie.substring(10));
                    break;
                }
            }
        }
        const csrfToken = csrftoken;
        return {
            app: 'ICD10',
            name: name,
            phone: number,
            email: email,
            subject: title,
            content: feedback,
            captcha: this.userCaptcha,
            csrfToken: csrfToken,
        };
    }

    private updateCaptchaImage(newCaptchaImageUrl: string) {
        const timestamp = new Date().getTime();
        this.captchaImageUrl = newCaptchaImageUrl + `?timestamp=${timestamp}`;
    }

    private handleSuccess(res: any) {
        this.captchaImageUrl = undefined;
        this.getListFeedback();
        if (res.message) {
            this.showingComments = true;
        }
    }

    private handleError(error: any) {
        this.errorMessage = error.error?.message;
        // this.contentMessage = error.error.data?.content;
        this.nameMessage = error.error.data?.name;
        this.emailMessage = error.error.data?.email;
        this.phoneMessage = error.error.data?.phone;
        this.subjectMessage = error.error.data?.subject;

        if (error.error.data?.captcha_image) {
            const newCaptchaImageUrl = BASE + error.error.data.captcha_image;
            this.updateCaptchaImage(newCaptchaImageUrl);
        }

        this.userCaptcha = '';
    }

    convertChapter(input: any): ChapterNode {
        return {
            id: input.data.id,
            model: input.model,
            code: input.data.code,
            name: input.data.name,
            level: 0,
            isLeaf: input.is_leaf,
            children: input.children?.map((child: any) => this.convertChapter(child)),
            span: input.data.id,
        };
    }

    getDetailModel(item: any) {
        this.isSearching = true;
        this.htmlRoot=""
        this.icdService.getDetailModel(item?.model, item?.id, this.language).subscribe(
            (res) => {
                this.infoModel = res.data.data;
                this.isSearching = false;
                this.setClickForCopy();
                this.setClickForEdit();
            },
            (error) => {
                this.isSearching = false;
                this.toastService.error(`${error?.error.error}`, 'Thất bại');
            }
        );
    }

    getChildrenOfModel(item: ChapterNode) {
        if (this.loaded.has(item.id)) {
            return;
        }
        this.loaded.add(item.id);
        this.icdService
            .getChildrenOfModel(item?.model, item?.id, this.language)
            .subscribe((res) => {
                const children = res.data.map((value: any) => this.convertChapter(value));
                item.children = children;
                this.dataSource.data = [];
                this.dataSource.data = this.chapter;
                setTimeout(() => {
                    this.treeControl.expand(item);
                });
            });
    }

    getChildrenOfTree(item: ChapterNode) {
        this.getChildrenOfModel(item);
        this.refreshTree();
    }

    goToDetail(item: ChapterNode) {
        this.isActive = item.id;
        this.getDetailModel(item);
    }

    receiveMessage($event: any) {
        this.infoModel = $event.data;
        this.isActive = $event.data.id;
        this.getListTreeOfSearch($event);
        this.handleScrollTree($event.data.id);
    }

    openItem(node: ChapterNode): void {
        // đệ quy
        if (node.children) this.treeControl.expand(node);
        node.children?.forEach((item, index) => {
            this.openItem(item);
        });
    }

    refreshTree() {
        let _data = this.dataSource.data;
        this.dataSource.data = [];
        this.dataSource.data = _data;
    }

    getListTreeOfSearch(item: any) {
        this.searchService
            .getListTreeOfSearch(item.model, item.id, this.language)
            .subscribe((res) => {
                const find = res.children.find((el: any) => el.children?.length > 0);
                const findnode = this.treeControl.dataNodes.find((dtn) => dtn.id === find.id);
                const children: ChapterNode[] = find.children.map((child: any) =>
                    this.convertChapter(child)
                );
                if (findnode) {
                    findnode.children = children;
                    this.dataSource.data = [];
                    this.dataSource.data = this.chapter;
                    this.openItem(findnode);
                }
            });
    }

    goToOpenTree(event: any) {
        event.preventDefault();
        let item = {
            model: '',
            id: '',
        };
        let href = '';
        let target = event.target || event.srcElement;
        while (target) {
            if (target instanceof HTMLAnchorElement) {
                href = target.getAttribute('href')!; //non-null assertion
                break;
            }
            target = target.parentNode;
        }
        item.id = href.split('/')[1];
        item.model = href.split('/')[0];
        if (item && item.id && item.model) {
            this.isActive = item.id;
            this.getListTreeOfSearch(item);
            this.getDetailModel(item);
            this.handleScrollTree(item.id);
        }
    }

    handleScrollTree(id: any) {
        setTimeout(() => {
            this.router.navigate([], { fragment: id }).then((res) => {
                const element = document.getElementById(id);
                if (element != undefined) element.scrollIntoView({ behavior: 'smooth' });
            });
        }, 1000);
    }
}
